import { useEffect } from "react";

export default function useWakeUpPing(intervalInMinutes = null) {
  useEffect(() => {
    const ping = () => {
      fetch("https://codaco-backend.onrender.com/ping").catch((err) =>
        console.error("Wake-up ping failed:", err)
      );
    };

    // Initial ping on mount
    ping();

    // Optional periodic ping
    if (intervalInMinutes) {
      const intervalMs = intervalInMinutes * 60 * 1000;
      const intervalId = setInterval(ping, intervalMs);
      return () => clearInterval(intervalId);
    }
  }, [intervalInMinutes]);
}
